import { TableCell } from '@mui/material';
import type { TableColumnComponent } from 'app/common/components/table/types';
import getImageUrl from 'app/common/utils/get-image-url';
import type React from 'react';
import styled from 'styled-components';

const imageDefaults = { w: 36, h: 36, fit: 'crop' };

const Thumbnail = styled.img`
  display: inline-block;
  vertical-align: middle;
  width: 1.625rem;
  height: 1.625rem;
  border-radius: 4px;
  overflow: hidden;
  margin: 0;
`;

export type ThumbnailCellProps = Pick<TableColumnComponent, 'value'>;

const ThumbnailCell: React.FC<ThumbnailCellProps> = ({ value }) => {
  const src = value?.path ? getImageUrl(value.path, imageDefaults) : (value?.src ?? value?.url);

  return (
    <TableCell align="center" padding="none">
      {src && <Thumbnail src={src} />}
    </TableCell>
  );
};

export default ThumbnailCell;
